import React, { Component } from 'react';
import IconTableHead from '../common/IconTableHead';
import PlayerId from '../common/PlayerId';
import VerticalPlayerId from '../common/VerticalPlayerId';
import * as utils from '../../shared/ClientUtils';
import AdvBasicTable from '../common/AdvBasicTable';
import AdvTippedText from '../common/AdvTippedText';

const WINNER_BG_COLOR = 'rgb(155, 255, 155)';
const LOSER_BG_COLOR = 'rgb(255, 230, 230)';
//const LOSER_BG_COLOR = undefined;

const WINNER_TEXT_COLOR = 'rgb(55, 155, 55)';
const LOSER_TEXT_COLOR = 'rgb(155, 55, 55)';
const PROFILE_PIC_PROPS = {
  limitWidth: '60%',
  limitMargin: '20%',
};

const PAST_LIMIT_MS = 30 * 60 * 1000;

class StackedPlayerId extends Component {
  render() {
    return (
      <a href={'/user/' + this.props._id} style={{ cursor: 'pointer' }}>
        <div>{this.props.name.split(' ')[0]}</div>
        <div>{this.props.name.split(' ')[1]}</div>
      </a>
    );
  }
}

function getMatchTimeUi(datetime) {
  const date = new Date(datetime);
  const now = new Date();
  let ms = date.getTime() - Date.now();

  if (ms > 0 && now.getDate() !== date.getDate()) {
    return (
      date.toLocaleDateString(undefined, { weekday: 'short' }) +
      ' ' +
      date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })
    );
  }

  const inPast = ms < 0;
  if (ms <= 0) {
    ms = -ms;
  }

  const min = Math.round(ms / 60000);
  const uiHr = Math.floor(min / 60);
  const uiMin = min % 60;

  const timeStr = uiHr > 0 ? `${uiHr}h ${uiMin}m` : `${uiMin}m`;

  return inPast ? timeStr + ' ago' : 'in ' + timeStr;
}

function isMatchStarted(datetime) {
  return new Date(datetime).getTime() < Date.now();
}

export class MatchBox extends Component {
  render() {
    return (
      <div className='row'>
        <div className='col-12'>
          <AdvBasicTable
            noHead
            //style={{ overflowX: 'hidden' }}
            columns={[
              {
                key: 'uiStatus',
                alignRight: true,
                fixedWidth: '15%',
              },
              {
                key: 'uiNames',
                //fixedWidth: '85%',
              },
              {
                key: 'uiDateScore',
                fixedWidth: '20%',
              },
            ]}
            data={this.props.matches
              .filter(
                (m) =>
                  (m.leftScore != undefined && m.rightScore != undefined) ||
                  new Date(m.datetime).getTime() > Date.now() - PAST_LIMIT_MS
              )
              .slice(
                this.props.page * this.props.size,
                (this.props.page + 1) * this.props.size
              )
              .map(
                (match) =>
                  match != null && {
                    uiStatus: match.unplayed ? (
                      isMatchStarted(match.datetime) ? (
                        <img
                          style={{ height: 12, width: 12 }}
                          src='/live_button.gif'
                        />
                      ) : (
                        <img
                          style={{ height: 12, width: 12 }}
                          src='/upcoming_match.png'
                        />
                      )
                    ) : (
                      <img
                        style={{ height: 12, width: 12 }}
                        src='/completed_match.png'
                      />
                    ),
                    uiDateScore: (
                      <div
                        style={{
                          padding: 0,

                          fontWeight: 'bold',
                        }}
                      >
                        <AdvTippedText
                          //text={<i className='icon-info'></i>}

                          text={
                            match.unplayed
                              ? getMatchTimeUi(match.datetime)
                              : match.leftScore + ' - ' + match.rightScore
                          }
                          //link={'/tournament/' + match.tournamentId}
                          tip={
                            <div>
                              <h5>{match.tournamentName}</h5>
                              <p>{'Round ' + match.roundToken}</p>
                              {match.hasElo ? (
                                <>
                                  <h5>ELO:</h5>
                                  <p>
                                    {match.leftElo + ' - ' + match.rightElo}
                                  </p>
                                  <p>
                                    {'(' +
                                      (match.leftEloDelta > 0
                                        ? '+' + match.leftEloDelta
                                        : match.leftEloDelta) +
                                      ')' +
                                      ' ' +
                                      '(' +
                                      (match.rightEloDelta > 0
                                        ? '+' + match.rightEloDelta
                                        : match.rightEloDelta) +
                                      ')'}
                                  </p>
                                </>
                              ) : (
                                ''
                              )}
                              {match.hasPr ? (
                                <>
                                  <h5>PR:</h5>
                                  <p>{match.leftPr + ' - ' + match.rightPr}</p>
                                </>
                              ) : (
                                ''
                              )}
                            </div>
                          }
                        />
                      </div>
                    ),
                    uiNames: (
                      <div>
                        <a
                          href={'/user/' + match.leftUserId}
                          style={{
                            fontWeight:
                              !match.unplayed &&
                              match.leftScore > match.rightScore
                                ? 'bold'
                                : undefined,
                          }}
                        >
                          {match.leftUserName}
                        </a>
                        {' - '}
                        <a
                          href={'/user/' + match.rightUserId}
                          style={{
                            fontWeight:
                              !match.unplayed &&
                              match.leftScore < match.rightScore
                                ? 'bold'
                                : undefined,
                          }}
                        >
                          {match.rightUserName}
                        </a>
                      </div>
                    ),
                  }
              )}
          />
        </div>
      </div>
    );
  }
}

export default MatchBox;
